import React, { FC } from 'react'
import { Route, Switch } from 'react-router-dom'

import { routes } from '../../constants/routes'
import { Users } from './Users'
import { CreateUser } from './CreateUser'
import { UserProfileTabs } from '../UserProfile/UserProfileTabs'
import { TransactionDetails } from '../UserProfile/UserTransactions/TransactionDetails'

export const UsersRoutes: FC = () => {
  return (
    <Switch>
      <Route path={`${routes.USERS}`} exact component={Users} />
      <Route path={`${routes.USER_CREATE}`} exact component={CreateUser} />
      <Route path={routes.USER_TRANSACTION_DETAILS} component={TransactionDetails} />
      <Route path={routes.USER_DETAILS_TABS} component={UserProfileTabs} />
    </Switch>
  )
}
